import React, { useMemo, useState } from "react";
import "../CustomerPreview.scss";
import { formatNumberIndian } from "../../../utilis/common-funtions";
import { getBookingAmountTotalFromApplicant } from "../../../utilis/bookingPaymentAmount";
import { useTranslation } from "react-i18next";
import { getAgreementPercentDisplayValue } from "./AgreementValueCalculationCard";
import { Grid } from "@mui/material";
import ReviewInput from "../../../components/ReviewInput";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
const { REACT_APP_S3_BASE_URL } = process.env;

const UnitDetails = ({ applicantData,bookingDocuments }) => {
  const { t } = useTranslation();
    const [fieldName, setFieldName] = useState("");
    const [openPopup, setOpenPopup] = useState(null);
  
  const unitDetails = applicantData?.unitDetails || {};
  const agreementPercentDisplay = getAgreementPercentDisplayValue(applicantData);
  const bookingAmountTotal = useMemo(
    () => getBookingAmountTotalFromApplicant(applicantData),
    [applicantData]
  );
  // Map bookingDocuments to same structure
  const documentsArray = Array.isArray(bookingDocuments)
    ? bookingDocuments
    : [];

  const bookingDocConfig = documentsArray?.map((doc) => ({
    key: doc?.name?.replace(/\s+/g, "")?.toLowerCase(),
    label:
      doc?.name === "Cost Sheet"
        ? t("unitDetails.labels.costSheet")
        : t("unitDetails.labels.allotmentLetter"),
    file: [doc?.path],
  }));

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };
  return (
    <div className="unitDetails">
      <div className="applicantDetailsCard">
        <div className="personalInformation marginBottom0">
          {unitDetails?.unitDetailImage &&
          unitDetails?.unitDetailImage?.length > 0 ? (
            <div className="photo">
              <img
                src={`${
                  REACT_APP_S3_BASE_URL + "/" + unitDetails?.unitDetailImage
                }`}
                className="unitProjectImage"
                alt="unit-image"
              />
            </div>
          ) : null}

          <div className="informationDetails">
            <h3 className="titlePersonalHD marginBottom28">
              {t("reviewYourDetails.corporate.steps.2")}
            </h3>
            <div className="personalInfo width50">
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.projectName")}:
                </p>
                <span>{unitDetails?.projectName || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.unitNumber")}:
                </p>
                <span>{unitDetails?.unitNumber || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.blockTower")}:
                </p>
                <span>{unitDetails?.blockTower || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.floor")}:
                </p>
                <span>{unitDetails?.floor || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.type")}:
                </p>
                <span>{unitDetails?.type || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.superBuiltArea")}:
                </p>
                <span>
                  {unitDetails?.superBuiltArea &&
                  unitDetails?.superBuiltArea !== null
                    ? formatNumberIndian(unitDetails?.superBuiltArea)
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.carpetArea")}:
                </p>
                <span>
                  {unitDetails?.carpetArea && unitDetails?.carpetArea !== null
                    ? formatNumberIndian(unitDetails?.carpetArea)
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.carParkType")}:
                </p>
                <span>{unitDetails?.carParkType || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200">
                  {t("unitDetails.labels.numOfCarPark")}:
                </p>
                <span>{unitDetails?.numOfCarPark || "N/A"}</span>
              </div>
              <div className="personalInfoRow">
                <p className="label200 ">
                  {t("unitDetails.labels.totalAgreementValue")}:
                </p>
                <span>
                  {unitDetails?.totalAgreementValue
                    ? `₹ ${formatNumberIndian(
                        Number.parseInt(unitDetails?.totalAgreementValue)
                      )}`
                    : "N/A"}
                </span>
              </div>
              <div className="personalInfoRow">
                <p className="label200 ">
                  {t("unitDetails.labels.bookingAmount")}:
                </p>
                <span>
                  {bookingAmountTotal > 0
                    ? `₹ ${formatNumberIndian(Math.round(bookingAmountTotal))}`
                    : unitDetails?.bookingAmount
                      ? `₹ ${formatNumberIndian(
                          Number.parseInt(unitDetails?.bookingAmount, 10)
                        )}`
                      : "N/A"}
                </span>
              </div>
              {unitDetails?.totalAgreementValue && (
                <div className="personalInfoRow">
                  <p className="label200">
                    {t("unitDetails.labels.ninePercentOfAV", {
                      percent: agreementPercentDisplay,
                    })}
                    :
                  </p>
                  <span>
                    {unitDetails?.ninePercentOfAV
                      ? `₹ ${formatNumberIndian(
                        Number.parseInt(unitDetails?.ninePercentOfAV)
                      )}`
                      : "N/A"}
                  </span>
                </div>
              )}
              {!applicantData?.primarySourceDisabled && (
                <div className="personalInfoRow">
                  <p className="label200">
                    {t("unitDetails.labels.primarySource")}:
                  </p>
                  <span>{unitDetails?.primarySource || "N/A"}</span>
                </div>
              )}
              {unitDetails?.primarySource === "Channel Partner" &&
                !applicantData?.primarySourceDisabled && (
                  <div className="personalInfoRow">
                    <p className="label200">
                      {t("unitDetails.labels.channel")}:
                    </p>
                    <span>{unitDetails?.channel || "N/A"}</span>
                  </div>
                )}
            </div>

          </div>
        </div>
        <Grid container rowSpacing={2} columnSpacing={10} mt={1}>
          {/* Render booking documents */}
          {bookingDocConfig?.map((doc) => (
            <Grid item xs={12} sm={6} md={6} lg={6} key={doc?.key}>
              <ReviewInput
                text={doc?.label}
                name={doc?.key}
                onView={handleView}
                disabled={!doc?.file?.length}
              />
            </Grid>
          ))}
        </Grid>
        {openPopup && (
          <UploadPopup
            heading="View"
            totalImages={1}
            closePopup={() => setOpenPopup(false)}
            uploadedImage={
              bookingDocConfig?.find((d) => d?.key === fieldName)?.file || []
            }
            fieldName={fieldName}
            hidePhysicalCopyOption
            dynamicSize={1}
            hideCameraOption={false}
            showDeleteIcon={false}
          />
        )}
      </div>
    </div>
  );
};

export default UnitDetails;
